import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from "src/environments/environment";
import { Permisos } from "src/app/_models/sesion/permisos";
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PermisosService {
  baseUrl = environment.baseUrl;
  baseUrl2 = environment.baseUrl2;

  constructor(private http: HttpClient) { }
  getPermisos(usuario) {
    return this.http.get(`${this.baseUrl}/login/getAllPermisos.php?codinter=${usuario}`);
  }

  getDatos(usuario) {
    return this.http.get(`${this.baseUrl}/login/datosUsuario.php?codinter=${usuario}`);
  }

  getIsintermediario(usuario){
    return this.http.get(`${this.baseUrl}/login/isIntermediario.php?codinter=${usuario}`);
  }
  
// Realizado 13/06/2025
  getUser(usuario){
    return this.http.get(`${this.baseUrl}/login/uservalidation.php?usuario=${usuario}`);
  }

  listarEjecutivos(data:{
    codinter: string,
    estado?: string,
  }) {
    const estado = data.estado ?? 'ACT'; // Valor por defecto 'ACT' si no se proporciona estado
    return this.http.post(`${this.baseUrl}/login/listarEjecutivos.php`, data);
  }

  // ValidarContrasena CODINTER
validarContrasena(codinter, password ){
  let postdata= {codinter:codinter,password:password};
  return this.http.post(`${this.baseUrl}/login/userModify.php`,
    postdata
  );  
}

// 27/11/2025

// // ...existing code...
// validarContrasena(codusr: string, password: string) {
//   // Backend decide PROD2020/COME2020 según CODGRPUSR
//   return this.http.post(`${this.baseUrl}/login/userModify.php`, { codusr, password });
// }
// // ...existing code...

// Fin 27/11/2025



// 05/11/2025
promoverEjecutivo(codusr: string, admin_codusr: string, payload: any){
  const url = `${this.baseUrl2}/user/${codusr}/role?admin_codusr=${admin_codusr}`;
  return this.http.put(url, payload);
}

changeStatus(codusr: string, admin_codusr: string, payload: any){
  const url = `${this.baseUrl2}/user/${codusr}/status?admin_codusr=${admin_codusr}`;
  return this.http.put(url, payload);
}

cambiarEjecutivo(codusr: string, admin_codusr: string, payload: any){
  const url =  `${this.baseUrl2}/user/${codusr}?admin_codusr=${admin_codusr}`;
  return this.http.put(url, payload);
}
// Fin 05/11/2025

// Crear Usuario 06/11/2025
crearUsuario(creatorCodusr: string, payload: any): Observable<any> {
  const url = `${this.baseUrl2}/user/executive?creatorCodusr=${creatorCodusr}`

    return this.http.post(url, payload);
} 

createManager(creatorCodusr: string, payload: any): Observable<any> {
  const url = `${this.baseUrl2}/user/manager?creatorCodusr=${creatorCodusr}`

  return this.http.post(url, payload);
}

// Fin 06/11/2025

// GET GERENTES & GET EJECUTIVOS -> 07/11/2025
  listarGerentes(admin_codusr: string){
    return this.http.get(`${this.baseUrl2}/user/my-managers?codusr_admin=${admin_codusr}`);
  }

  EjecutivosDeGerente(admin_codusr: string){
    return this.http.get(`${this.baseUrl2}/user/my-executives?codusr_gerente=${admin_codusr}`);
  }
}